import { scopeIncludesAor, type SitStatAorScope } from './sitstat-aor-scope';

export type SitStatTaskLike = {
  name: string;
  status?: string | null;
  target_date?: Date | string | null;
  aor_id?: string | null;
  archived?: boolean;
};

const DONE_STATUSES = new Set(['closed', 'completed', 'complete', 'cancelled']);

export function isSitStatTaskDone(task: Pick<SitStatTaskLike, 'status'>) {
  return DONE_STATUSES.has((task.status ?? '').trim().toLowerCase());
}

function targetMs(task: SitStatTaskLike): number {
  if (!task.target_date) return Number.POSITIVE_INFINITY;
  const ms = new Date(task.target_date).getTime();
  return Number.isNaN(ms) ? Number.POSITIVE_INFINITY : ms;
}

/**
 * Unarchived tasks inside the AOR scope, open work first, then by target date
 * (undated last), then by name.
 */
export function filterSitStatTasks<T extends SitStatTaskLike>(
  tasks: readonly T[],
  scope: SitStatAorScope | null
): T[] {
  return tasks
    .filter(
      (task) => !task.archived && scopeIncludesAor(scope, task.aor_id ?? null)
    )
    .sort((a, b) => {
      const doneDiff =
        Number(isSitStatTaskDone(a)) - Number(isSitStatTaskDone(b));
      if (doneDiff !== 0) return doneDiff;
      const aMs = targetMs(a);
      const bMs = targetMs(b);
      if (aMs !== bMs) return aMs < bMs ? -1 : 1;
      return (a.name ?? '').localeCompare(b.name ?? '');
    });
}
